import React, { useState } from 'react';
import { Plug } from 'lucide-react';

/**
 * Renders connector logo from API fields only (never connectorId asset maps).
 */
const ConnectorLogo = ({ logoUrl, logoAlt, logoDarkUrl, className = 'h-10 w-10', preferDark = false }) => {
  const [failed, setFailed] = useState(false);
  const src = preferDark && logoDarkUrl ? logoDarkUrl : logoUrl;

  if (!src || failed) {
    return (
      <div
        className={`flex items-center justify-center rounded-md bg-muted text-muted-foreground ${className}`}
        aria-label={logoAlt || 'Connector'}>
        <Plug size={20} strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={logoAlt || 'Connector logo'}
      className={`object-contain ${className}`}
      onError={() => setFailed(true)}
    />
  );
};

export default ConnectorLogo;
